import Icon1 from "@assets/icons/Icon";
import { useState } from "react";
import { colors } from "sexy";

type SideMenuButtonProps = {
  label: string;
  onClick?: () => void;
  className?: string;
  name?: string;
  size?: "medium" | "small" | "large";
  color?: string;
};

export default function SideMenuButton({
  size = "medium",
  color = "#000000",
  ...props
}: SideMenuButtonProps) {
  return (
    <div
      onClick={props.onClick}
      className={`
        ${size === "small" ? "px-1.5 py-1" : size === "medium" ? "px-2 pr-4 py-1.5 text-h3" : "px-3 py-2 text-h2"}
        flex flex-row gap-2  w-full items-center  hover:bg-gray-100 rounded-lg cursor-pointer `}
    >
      {props.name && (
        <Icon1
          name={props.name}
          size={size === "small" ? 16 : size === "medium" ? 20 : 22}
          color={color}
        />
      )}
      <div
        style={{
          color: color,
        }}
        className={` font-medium  `}
      >
        {props.label}
      </div>
    </div>
  );
}
